import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setStainColorOverrides } from '../../reducers/BuildRenderRequestSlice';
import { useGetSettingsQuery } from '../../services/chromosomeApi';
import { ColorTable } from '../Common/ColorTable';

export const BandStains = () => {
  const dispatch = useDispatch();
  const { isLoading, data } = useGetSettingsQuery();
  const { stainColorOverrides } = useSelector((state: RootState) => state.buildRenderRequest);
  return (
    <ColorTable
      isLoading={isLoading}
      colors={data?.bandStains || []}
      selectedColors={stainColorOverrides}
      colorChanges={(colors) => dispatch(setStainColorOverrides(colors))}
    />
  );
};
